import type { WhatsNewBody } from '../types';

export default {
  title: 'An imported schedule now shows its headers',
  summary:
    'A schedule imported from Microsoft Project now keeps its outline on the Schedule tab. The phases and areas show as header rows, with their tasks indented underneath, in the same order as the file.',
  details: [
    'On a job, open the Schedule tab. A header is in bold, with a gray bar for the span of everything under it.',
    'Tasks stay under their own header. They are no longer mixed together by start date across the whole job.',
    'A schedule you already imported shows its headers too, so there is nothing to import again.',
    'The 3-week look-ahead is unchanged: it still lists the tasks, not the headers.',
  ],
  audience: { label: 'project managers and engineers', test: (a) => a.editsProjects },
  tryIt: { to: '/projects', label: 'Open Projects' },
} satisfies WhatsNewBody;
